module.exports = __webpack_public_path__ + "img/action-dark.fd759025.svg";